import React from 'react';
import Input from 'components/inputs/Input';
import { toInputDateTimeString } from 'utils/date-helpers';

type OrderInputProps = {
  assignmentBookedTo: Date;
  bookedTo: string;
  setBookedTo: (value: string) => void;
};

const OrderInput: React.FC<OrderInputProps> = ({
  assignmentBookedTo,
  bookedTo,
  setBookedTo,
}) => {
  return (
    <Input
      max={toInputDateTimeString(assignmentBookedTo)}
      onChange={(e) =>
        setBookedTo(toInputDateTimeString(new Date(e.currentTarget.value)))
      }
      small
      type="datetime-local"
      value={bookedTo}
    />
  );
};

export default OrderInput;
